import React from 'react';
import { Image } from 'src/lib/StyledComponents';
import styles from './index.css';

const AnimatedLogo = ({ style, fadein }) => (
	<Image
		src="/wisely_animated_logo.gif"
		alt="Wisely animated logo"
		{...style}
		className={fadein ? styles.fadein : undefined}
	/>
);

export default AnimatedLogo;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/utils/AnimatedLogo/index.js